import { FC } from 'react';
import { Link } from 'react-router-dom';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';

import { MenuRowContent } from '../../MenuRowContent/MenuRowContent';
import { CREATE_MENU_ITEM_TYPE, CreateMenuItem } from '../CreateButton.types';

interface CreateActionMenuItemProps {
  item: CreateMenuItem;
  onSelect: () => void;
}

export const CreateActionMenuItem: FC<CreateActionMenuItemProps> = ({
  item,
  onSelect,
}) => {
  if (item.type === CREATE_MENU_ITEM_TYPE.TITLE) {
    return (
      <div className="px-2 py-1.5 text-xs font-medium stext-muted-default">
        {safeFormattedIntlString(item.label)}
      </div>
    );
  }

  if (item.type === CREATE_MENU_ITEM_TYPE.LINK) {
    return (
      <Link
        to={item.isDisabled ? '#' : (item.href ?? '#')}
        onClick={item.isDisabled ? undefined : onSelect}
        aria-disabled={item.isDisabled}
        data-testid={`menu_${item.key}`}
        className={
          'flex items-center gap-2 rounded-sm px-2 py-1.5 text-sm stext-base-default ' +
          'hover:bg-surface-base-hover aria-disabled:pointer-events-none aria-disabled:stext-disabled-default'
        }
      >
        <MenuRowContent icon={item.icon}>
          {safeFormattedIntlString(item.label)}
        </MenuRowContent>
      </Link>
    );
  }

  return (
    <button
      type="button"
      disabled={item.isDisabled}
      data-testid={`menu_${item.key}`}
      onClick={(event) => {
        item.onClick(item, event);
        onSelect();
      }}
      className={
        'flex w-full cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-left text-sm stext-base-default ' +
        'hover:bg-surface-base-hover disabled:pointer-events-none disabled:stext-disabled-default'
      }
    >
      <MenuRowContent icon={item.icon}>
        {safeFormattedIntlString(item.label)}
      </MenuRowContent>
    </button>
  );
};
